export const distanceSlopes: {
    label: string;
    criterias: string[];
    isAvailable: {
        criterias: string[];
    };
}[] = [
    {
        label: 'Au pied des pistes',
        criterias: ['291'],
        isAvailable: {
            criterias: ['291']
        }
    },
    {
        label: '200 mètres max',
        criterias: ['291', '285'],
        isAvailable: {
            criterias: ['285']
        }
    },
    {
        label: '500 mètres max',
        criterias: ['291', '285', '286'],
        isAvailable: {
            criterias: ['286']
        }
    },
    {
        label: '1 km max',
        criterias: ['291', '285', '286', '287'],
        isAvailable: {
            criterias: ['287']
        }
    },
    {
        label: '5 Km max',
        criterias: ['291', '285', '286', '287', '288'],
        isAvailable: {
            criterias: ['288']
        }
    },
    {
        label: '20 Km max',
        criterias: ['291', '285', '286', '287', '288', '289'],
        isAvailable: {
            criterias: ['289']
        }
    },
    {
        label: 'A + de 20 Km',
        criterias: ['291', '285', '286', '287', '288', '289', '290'],
        isAvailable: {
            criterias: ['290']
        }
    }
]